import { Link } from 'react-router-dom'
import { Star, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { HomePropertySection } from '@/components/home/HomePropertySection'
import { useCityStore } from '@/store/cityStore'
import { PATHS } from '@/routes/paths'
import { buildPropertyHref } from '@/lib/propertyNavLinks'
import type { Property } from '@/types/property'

export function HomePagePropertySections({
  premiumProjects,
  recommendedForSale,
  recommendedForRent,
  isLoading,
}: {
  premiumProjects: Property[]
  recommendedForSale: Property[]
  recommendedForRent: Property[]
  isLoading?: boolean
}) {
  const { cityName } = useCityStore()
  const city = cityName.toLowerCase()
  const verifiedHref = buildPropertyHref('buy', { city, verified: 'true' })
  const saleHref = buildPropertyHref('buy', { city })
  const rentHref = buildPropertyHref('rent', { city })

  return (
    <>
      <HomePropertySection
        first
        tinted
        title="QBC Verified Properties"
        subtitle={`All verified listings in ${cityName}`}
        viewAllHref={verifiedHref}
        properties={premiumProjects}
        isLoading={isLoading}
        action={
          <div className="hidden items-center gap-2 md:flex md:shrink-0 md:justify-end">
            <Button asChild variant="premium" size="sm" className="min-w-0 flex-1 sm:flex-none">
              <Link to={verifiedHref}>
                <Star className="h-4 w-4 shrink-0" /> Explore Verified
              </Link>
            </Button>
            <Button asChild variant="premium" size="sm" className="min-w-0 flex-1 sm:flex-none">
              <Link to={PATHS.premium}>
                <span className="truncate">View Premium Packages</span>
                <ArrowRight className="h-4 w-4 shrink-0" />
              </Link>
            </Button>
          </div>
        }
      />

      <HomePropertySection
        title={`Properties for Sale in ${cityName}`}
        viewAllHref={saleHref}
        properties={recommendedForSale}
        isLoading={isLoading}
      />

      <HomePropertySection
        title={`Properties for Rent in ${cityName}`}
        viewAllHref={rentHref}
        properties={recommendedForRent}
        isLoading={isLoading}
      />
    </>
  )
}
